module.exports = __webpack_public_path__ + "static/media/arrow.8af3f4e5.svg";